import { PrimaryButton, SecondaryButton } from '@shape-ds/components';
import './style.scss';
import { ReactNode } from 'react';

type BtnModalProps = {
  style: 'primary' | 'secondary';
  text: string;
  onClick?: () => void;
};

export enum ModalWidthEnum {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
}

export enum ModalAlignBtnEnum {
  LEFT = 'left',
  RIGHT = 'right',
}

export type GenericModalProps = {
  title: string;
  description?: string;
  classname?: string;
  width?: ModalWidthEnum;
  leftBtn?: BtnModalProps;
  rightBtn?: BtnModalProps;
  children?: ReactNode;
  alignBtnTo?: ModalAlignBtnEnum;
};

export const GenericModal = ({
  title,
  description,
  classname,
  width = ModalWidthEnum.MEDIUM,
  leftBtn,
  rightBtn,
  children,
  alignBtnTo = ModalAlignBtnEnum.LEFT,
}: GenericModalProps) => {
  const buttonsCount = [leftBtn, rightBtn].filter(Boolean).length;
  const isSingleButton = buttonsCount === 1;

  const renderButton = (btn?: BtnModalProps) => {
    if (!btn) return null;
    const ButtonComponent = btn.style === 'primary' ? PrimaryButton : SecondaryButton;

    return (
      <ButtonComponent
        className={`${
          btn.style === 'primary' ? 'primary-color' : 'secondary-color'
        } generic-modal-button`}
        onClick={btn.onClick}
        data-testid={`generic-modal-${btn.style}-button`}
      >
        {btn.text}
      </ButtonComponent>
    );
  };
  return (
    <div
      className={`${classname ?? ''} generic-modal-wrapper generic-modal-${width}`}
      data-testid="generic-modal"
    >
      <div className={`generic-modal-content ${isSingleButton ? 'center-text' : 'left-text'}`}>
        {children && (
          <div className="generic-modal-icon" data-testid="generic-modal-title">
            {children}
          </div>
        )}
        <div className="generic-modal-title">{title}</div>
        {description && (
          <div className="generic-modal-description" data-testid="generic-modal-description">
            {description}
          </div>
        )}
      </div>
      <div
        className={`generic-modal-buttons ${isSingleButton ? 'center-buttons' : 'left-buttons'}`}
        data-testid="generic-modal-btn"
      >
        <div
          className={`${
            alignBtnTo === ModalAlignBtnEnum.LEFT
              ? 'generic-modal-left-buttons'
              : 'generic-modal-right-buttons'
          }`}
        >
          {renderButton(leftBtn)}
          {renderButton(rightBtn)}
        </div>
      </div>
    </div>
  );
};
